export const DEFAULT_ROWS_PER_PAGE = 25

export const MINIMUM_ROWS_PER_PAGE = 10

export const MAXIMUM_ROWS_PER_PAGE = 50
